import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "../Navigation/Navigation.js";
import "../Layout/Layout.css";
import TopBar from "../TopBar/top-bar.js";
import ActiveBannerAlertBar from "../BannerAlerts/ActiveBannerAlertBar.js";
import PhoneHeader from "../../common/phone-header/index.js";
import { useScreen } from "../Utils/Screens.js";
import { useAuth } from '../AuthProvider.js';

function Layout({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  // Keyed on the path only: query-string changes (AABI drill/date/measure,
  // invoice filters, etc.) must NOT remount page content — the URL is shared
  // state, and remounting on every param change resets local state and refetches
  // unrelated data (AABI Stage 1 UI upgrade §9.3).
  const contentKey = location.pathname;
  const [userType, setUserType] = React.useState(null);
  const [userData, setUserData] = React.useState(null);
  const [hasActiveAlert, setHasActiveAlert] = React.useState(false);
  const [activeAlertHeight, setActiveAlertHeight] = React.useState(0);

  const [closeSidebar, setCloseSidebar] = useState(false);
  const [closePhoneSidebar, setClosePhoneSidebar] = useState(false);

  const isPhone = !useScreen("sm");

  React.useEffect(() => {
    const userData = user;
    if (userData) {
      setUserData(userData);
      setUserType(userData.Type);
    }
  }, []);

  const handleAlertVisibilityChange = React.useCallback((alertState) => {
    if (!alertState || !alertState.hasAlert) {
      setHasActiveAlert(false);
      setActiveAlertHeight(0);
      return;
    }

    setHasActiveAlert(true);
    setActiveAlertHeight(alertState.height || 0);
  }, []);

  return isPhone ? (
    <div className={`container-phone`}>
      {userType && userData && (
        <>
          <PhoneHeader
            toggleSidebar={() => setClosePhoneSidebar(!closePhoneSidebar)}
          />
          {closePhoneSidebar && (
            <div
              className="sidebar-phone-backdrop"
              onClick={() => setClosePhoneSidebar(false)}
            />
          )}
          <div className={`sideBar-phone ${closePhoneSidebar ? "open" : ""}`}>
            {closePhoneSidebar ? (
              <Navigation
                userType={userType}
                userData={userData}
                closeSidebar={false}
                setClosePhoneSidebar={setClosePhoneSidebar}
              />
            ) : (
              <></>
            )}
          </div>
          <div key={contentKey} style={{ padding: "24px" }}>
            {children}
          </div>
        </>
      )}
    </div>
  ) : (
    <>
      <ActiveBannerAlertBar
        onAlertVisibilityChange={handleAlertVisibilityChange}
      />
      <div
        className={`container ${closeSidebar ? "collapsed" : "expanded"} ${
          hasActiveAlert ? "alert" : ""
        }`}
        style={{
          "--active-alert-height": `${activeAlertHeight}px`,
        }}
      >
        {userType && userData && (
          <>
            {location.pathname !== "/Login" && (
              <div className="sideBar">
                <Navigation
                  userType={userType}
                  userData={userData}
                  closeSidebar={closeSidebar}
                  toggleSidebar={() => setCloseSidebar(!closeSidebar)}
                />
              </div>
            )}

            <div className="right-container">
              <TopBar />
              <div key={contentKey} className="content-container">
                {children}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Layout;
